import { useQuery } from '@tanstack/react-query';
import { userService } from '@/api/services/UserService';
import { useAuth } from '@/stores/authContext';

export const PROFILE_QUERY_KEY = ['profile'] as const;

// Профиль пользователя (server-state). Включён только при авторизации. Повторы — у транспорта.
export function useProfile() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: () => userService.getProfile(),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
  });
}
